import { Permissao } from '@/types/administracao/cadastro-permissoes/permissao';
import { Service } from '../mainService';

const usuariosService = {
    //permissoes
    buscarPermissoes,
    buscarPermissao,
    adicionarPermissao,
    editarPermissao,
    buscarPerfis,
    removerPermissao,
    inativarRota
}

async function buscarPermissoes() {
    try {
        const response = Service.$http.get(process.env.VUE_APP_USERS_API + "/permissoes/listar");
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function buscarPermissao(id: number) {
    try {
        const response = Service.$http.get(process.env.VUE_APP_USERS_API + "/permissoes/buscar/"+id);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function adicionarPermissao(data: Permissao) {
    try {
        const response = Service.$http.post(process.env.VUE_APP_USERS_API + "/permissoes/adicionar", data);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function editarPermissao(data: Permissao) {
    try {
        const response = Service.$http.post(process.env.VUE_APP_USERS_API + "/permissoes/editar/" + data.Id, data);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function buscarPerfis() {
    try {
        const response = Service.$http.get(process.env.VUE_APP_USERS_API + "/permissoes/listarperfis");
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function removerPermissao(id: number) {
    try {
        const response = Service.$http.delete(process.env.VUE_APP_USERS_API + "/permissoes/remover/"+id);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function inativarRota(id: number) {
    try {
        const response = Service.$http.post(process.env.VUE_APP_USERS_API + "/permissoes/inativar/"+id);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

export default usuariosService;